import { GA_Push } from './analytics';
const LeadID = 79;

const Environment = () => {
    var isLocalhost = Boolean(
        window.location.hostname === "localhost" ||
        window.location.hostname === "[::1]" ||
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    var isQA = Boolean(
        window.location.href.match("source-qa") || window.location.href.match("qa.")
    );

    var isSource = Boolean(window.location.href.match("source-"));

    return {
        isLocalhost: isLocalhost,
        isQA: isQA,
        isTest: isQA || isLocalhost,
        isSource: isSource,
    };
};

const switchURLapi = (LocalHost, QADomain, PRODDomain) => {
    if (Environment().isLocalhost) {
        return LocalHost;
    } else {
        if (Environment().isQA) {
            return QADomain;
        } else {
            if (Environment().isQA) {
                return QADomain;
            } else {
                return PRODDomain;
            }
        }
    }
};

const apiURL = switchURLapi(
    "https://Api_Leads/api/",
    "https://qa-a.ynet.co.il/mShort/generics/Leads/api/api/",
    "https://z.ynet.co.il/mShort/generics/Leads/api/api/"
);

export const sendLead = async (leadData) => {
    var success = true;
    try {
        //creates new formdata
        var form = new FormData();

        //initializes object with values
        const jsonData = {
            FullName: leadData.name,
            Email: leadData.email,
            PhoneNumber: leadData.phone,
            LeadID: LeadID
        };

        //puts object inside the form data
        for (var key in jsonData) {
            form.append(key, jsonData[key]);
        }

        //checks if already exists in db
        let isExists = await fetch(`${apiURL}IsExists`, {
            method: "POST",
            body: form,
        }).then((data) => console.log(data));

        if (isExists) {
            alert("לא ניתן להירשם יותר מפעם אחת");
            return false;
        }

        //saves to db
        fetch(`${apiURL}Save`, {
            method: "POST",
            body: form,
        })
            .then((data) => data.json())
            .then((data) => {
            });
    } catch {
        GA_Push("Send Form", "Fail");
        success = false;
    }

    if (success) {
        GA_Push("Send Form", "Success");

        window.parent.postMessage({
            yedioth_frame_finish: true,
        }, "*")

    }
};

export const sendActiveTrail = async (activeTrailData) => {
    try {
        //creates new formdata
        var form = new FormData();

        //initializes object with values
        const jsonData = {
            email: activeTrailData.email,
            first_name: "",
            ext1: ""
        };

        //puts object inside the form data
        for (var key in jsonData) {
            form.append(key, jsonData[key]);
        }

        //send to activetrail
        fetch(`${apiURL}SendActiveTrail`, {
            method: "POST",
            body: form,
            //body: JSON.stringify(object)
            //headers: {
            //    'Content-Type': 'application/json',
            //}
        })
            //.then((data) => data.json())
            .then((data) => {
                //console.log(data);
                if (data.statusText == "OK") {
                    GA_Push("Send Form", "Success");
                    window.parent.postMessage({
                        yedioth_frame_finish: true,
                    }, "*")
                }
                else if (data == "Fail") {
                    GA_Push("Send Form", "Fail");
                }

            });
    } catch {
        GA_Push("Send Form", "Fail");
    }
};
